// extracted by mini-css-extract-plugin
export default {"image":"UploadWidget_image__M9NY7"};